<template>
  <v-row>
    <v-col cols="12">
      <v-stepper :alt-labels="true" v-model="stepperStep">
        <v-stepper-header>
          <v-stepper-step :complete="stepperStep > 1" step="1"
            >Datos Básicos</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step :complete="stepperStep > 2" step="2"
            >Fuentes de Datos</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step :complete="stepperStep > 3" step="3"
            >Análisis</v-stepper-step
          >
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1" class="px-2">
            <v-card class="mb-12" :elevation="0">
              <v-form ref="formStep1">
                <v-row class="mx-2">
                  <v-col class="align-center justify-space-between" cols="12">
                    <v-text-field
                      v-model="name"
                      placeholder="Nombre"
                      :rules="nameRules"
                      autocomplete="off"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="description"
                      placeholder="Descripción"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="dashboard"
                      :items="dashboards"
                      label="Dashboard"
                      :rules="required"
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="interval"
                      :items="intervals"
                      label="Monitorear"
                      clearable
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-checkbox
                      v-model="copraApp"
                      label="Visible en CopraApp"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
            <v-btn to="/datasets" class="ma-2" text>Cancelar</v-btn>
            <v-btn color="primary" @click="goStep2" class="ma-2"
              >Siguiente</v-btn
            >
          </v-stepper-content>
          <v-stepper-content step="2" class="px-2">
            <v-card class="mb-md-12" :elevation="0">
              <v-card-text
                v-if="sources.length == 0"
                class="text-center pt-10 body-1"
                >Debes adicionar al menos una fuente de datos al
                dataset.</v-card-text
              >
              <v-card-text v-else>
                <sources-table
                  :sources="sources"
                  v-on:delete-source="deleteSource"
                ></sources-table>
              </v-card-text>
            </v-card>
            <v-btn class="ma-2" @click="cancelWizard">Cancelar</v-btn>
            <v-btn
              color="secondary"
              @click="showSourcesModal = true"
              class="ma-2"
            >
              <v-icon size="20">mdi-plus</v-icon>Fuentes
            </v-btn>
            <v-btn
              color="primary"
              @click="goStep3"
              :disabled="sources.length == 0"
              class="ma-2"
              >Analizar</v-btn
            >
          </v-stepper-content>
          <v-stepper-content step="3" class="px-2">
            <v-card :elevation="0">
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <div class="button">Nombre:&nbsp;{{ name }}</div>
                    <div class="button" v-if="description">
                      Nombre:&nbsp;{{ description }}
                    </div>
                    <div class="button">
                      Fuentes:&nbsp; {{ sources.length }}
                    </div>
                    <div class="button">
                      CopraApp:&nbsp;{{ copraApp ? "Sí" : "No" }}
                    </div>
                    <div class="button" v-if="interval">
                      Monitorear:&nbsp;{{ interval }}
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <div class="button">
                      {{
                        progress > 0
                          ? "Analizando Dataset..."
                          : "Consultando Fuentes..."
                      }}
                    </div>
                    <v-progress-linear
                      v-model="progress"
                      color="primary"
                      height="25"
                      dark
                    >
                      <strong>{{ Math.ceil(progress) }}%</strong>
                    </v-progress-linear>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-btn
              color="primary"
              @click="viewDataset"
              class="ma-2 ml-4"
              :disabled="progress < 100"
              >Ver Dataset</v-btn
            >
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>

      <sources-modal
        key="sources-wizard"
        :datasetUid="datasetUid"
        :showModal="showSourcesModal"
        @hide-modal="showSourcesModal = false"
        @add-source="addSource($event)"
      />
    </v-col>
  </v-row>
</template>

<script>

import SourcesTable from "@/components/datasets/SourcesTable.vue";
import SourcesModal from "@/components/datasets/SourcesModal.vue";

export default {  
  data() {
    return {
      stepperStep: 1,
      datasetUid: "",
      name: "",
      description: "",
      dashboard: "",
      dashboards: [],
      interval: "",
      intervals: [
        {
          value: "1h",
          text: "Cada 1 Hora",
        },
        {
          value: "6h",
          text: "Cada 6 Horas",
        },
        {
          value: "1d",
          text: "Diariamente",
        },
        {
          value: "1w",
          text: "Semanalmente",
        },
      ],
      copraApp: false,
      processing: false,
      progress: 0,
      progressInterval: null,
      showSourcesModal: false,
      sources: [],
      nameRules: [
        (v) => !!v || "El nombre es requerido",
        (v) =>
          (v && v.length >= 5) ||
          "El nombre debe contener al menos 5 carácteres",
      ],
      required: [(v) => !!v || "Este campo es requirido"],
    };
  },
  components: {
    SourcesTable,
    SourcesModal,
  },
  mounted() {
    this.$http.get("/api/dashboards").then((response) => {
      console.log(response.data);
      this.dashboards = response.data.dashboards.map((entry) => {
        if (entry.isDefault) {
          this.dashboard = entry.id;
        }
        return {
          value: entry.id,
          text: entry.name,
        };
      });
    });
  },
  beforeDestroy: function () {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }
  },
  methods: {
    goStep2() {
      if (this.$refs.formStep1.validate()) {
        this.createDataset();
        this.stepperStep = 2;
      }
    },
    goStep3() {
      this.analyzeDataset();
      this.stepperStep = 3;
      this.progressInterval = setInterval(() => {
        this.$http.get(`/api/datasets/${this.datasetUid}`).then((response) => {
          console.log(response.data);
          if (response.data.dataset) {
            this.progress = response.data.dataset.progress;
            if (response.data.dataset.status == 'available') {
              clearInterval(this.progressInterval);
              this.progress = 100;
            }
          }
        });
      }, 2000);
    },
    cancelWizard() {
      this.deleteDataset();
      this.stepperStep = 1;
      this.$router.push({ path: "/datasets" });
    },
    sortDateRange(dateRange) {
      if (dateRange.length == 2) {
        let date1 = new Date(dateRange[0]);
        let date2 = new Date(dateRange[1]);
        if (date1 < date2) {
          return dateRange;
        } else {
          return [dateRange[1], dateRange[0]];
        }
      }
    },
    addSource(source) {
      console.log(source);
      this.$http
        .post(`/api/datasets/${this.datasetUid}/sources`, {
          datasetUid: this.datasetUid,
          ...source,
        })
        .then((response) => {
          console.log(response.data);
          this.sources.push(source);
          this.showSourcesModal = false;
        });
    },
    deleteSource(index) {
      this.sources.splice(index, 1);
    },
    createDataset() {
      this.$http
        .post("/api/datasets", {
          dataset: {
            dashboardId: this.dashboard,
            name: this.name,
            description: this.description,
            interval: this.interval,
            appEnabled: this.copraApp,
          },
        })
        .then((response) => {
          console.log(response.data);
          this.datasetUid = response.data.dataset.uid;
        });
    },
    deleteDataset() {
      this.$http.delete(`/api/datasets/${this.datasetUid}`, {}).then((response) => {
        console.log(response.data);
        this.datasetUid = null;
        this.name = "";
        this.description = "";
        this.interval = "";
        this.copraApp = false;
      });
    },
    analyzeDataset() {
      this.$http.post(`/api/datasets/${this.datasetUid}/analyze`, {}).then((response) => {
        console.log(response.data);
      });
    },
    viewDataset() {
      this.$router.push({ path: `/datasets/${this.datasetUid}/search` });
    },
  },
  computed: {
    newsDateRangeText() {
      if (this.news.dates.length == 2) {
        return this.sortDateRange(this.news.dates).join(" ~ ");
      }
      return "";
    },
    mapHeigth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
          return "240px";
        case "md":
        case "lg":
        case "xl":
          return "320px";
      }
      return "320px";
    },
    mapSelectedRadious() {
      return this.map.ticksLabels[this.map.radious];
    },
  },
};
</script>